import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { Button, FieldTextInput, Form } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';
import css from './PasswordWallForm.module.css';
import { composeValidators, required } from '../../../../util/validators';

const PasswordWallForm = props => (
    <FinalForm
        {...props}
        render={fieldRenderProps => {
            const {
                form,
                handleSubmit,
                onChange,
                invalid,
                pristine,
                submitting,
                intl
            } = fieldRenderProps;

            return (
                <Form onSubmit={(values) => handleSubmit(values, form)}>
                    <div className={css.commingSoonWrapper}>
                        <div className={css.heading}>
                            <FormattedMessage id="PasswordWallForm.passwordWall" />
                        </div>
                        <div className={css.descriptionText}>
                            <FormattedMessage id="PasswordWallForm.passwordWallDescription" />
                        </div>
                        <div>
                            <FieldTextInput
                                className={css.inputBox}
                                id={'username'}
                                name={'username'}
                                type="text"
                                placeholder={intl.formatMessage({id: 'PasswordWallForm.UsernamePlaceholder'})}
                                label={intl.formatMessage({id: 'PasswordWallForm.Username'})}
                                validate={composeValidators(required(intl.formatMessage({id: 'PasswordWallForm.userNameRequired'})))}
                            />
                            <FieldTextInput
                                className={css.inputBox}
                                id={'password'}
                                name={'password'}
                                type="text"
                                placeholder={intl.formatMessage({id: 'PasswordWallForm.passwordPlaceholder'})}
                                label={intl.formatMessage({id: 'PasswordWallForm.password'})}
                                validate={composeValidators(required(intl.formatMessage({id: 'PasswordWallForm.passwordRequired'})))}
                            />
                        </div>
                    </div>
                    <Button className={css.submitButton} type="submit" >
                        <FormattedMessage id="PasswordWallForm.passwordWallButtonText" />
                    </Button>
                </Form>
            );
        }}
    />
);

export default PasswordWallForm;
